/*
 NOTE: this should closely match js/widgets/generators/tpl/numeric.js -> numericItem
 */
export const refinementItem = `
  <label class="text-base text-gray-600 flex items-center justify-between cursor-pointer">
    <div class="flex items-center">
        <input type="checkbox" class="h-5 w-5 border-gray-300  text-red-500 focus:ring-2" {{#isRefined}}checked="true"{{/isRefined}}>
        <span class="ml-3 ">{{label}}</span>
    </div>

      <span class="text-2xs bg-gray-100 rounded-full leading-none px-2 py-1 text-gray-400 mr-4">{{count}}</span>
  </label>
`;

export const refinementClasses = {
    item: ['cursor-pointer'],
    noRefinementRoot: 's-no-results',
    list: ['mb-1 py-5 space-y-3 -mt-4'],
}
